import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { PaymentOrder, PaymentsQuery } from '../gql-types.generated';
import { getStandardHeaders } from '../util/StandardRequestHeaders';

const QUERY_PAYMENTS = gql`
  query payments($after: String, $before: String, $first: Int, $last: Int, $orderBy: PaymentOrder!, $queryString: String) {
    payments(after: $after, before: $before, first: $first, last: $last, orderBy: $orderBy, queryString: $queryString) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      nodes {
        id
        status
        pendingReason
        amount
        amountDisputed
        amountRefunded
        attemptTimestamp
        completedTimestamp
        createdAt
        cancelReason
        currency
        failureReason
        feeAmount
        immediateCapture
        initiatedBy
        owner {
          tenantId
          paymentRequestId
        }
        refunds {
          amount
          attemptTimestamp
          currency
          id
          refundReason
          status
          createTime
          owner {
            tenantId
          }
          payment {
            id
            amount
          }
        }
        paymentRequest {
          amount
          communications {
            communicationType
            email
            phoneNumber
            requestTimestamp
            sentTimestamp
          }
          createdAt
          createdBy
          id
          invoiceLink
          invoiceId
          referenceNumber
          status
          statusReason
          payments {
            id
            status
            amount
            amountRefunded
          }
          owner {
            paymentId
            tenantId
            disputeId
          }
        }
      }
      edges {
        cursor
        node {
          id
        }
      }
    }
  }
`;

export const queryPaymentConnection = async (
  client: ApolloClient<NormalizedCacheObject>,
  after: string | undefined,
  before: string | undefined,
  first: number | undefined,
  last: number | undefined,
  orderBy: PaymentOrder,
  queryString: string | undefined,
) => {
  const headers = await getStandardHeaders();
  const { data, errors } = await client.query<PaymentsQuery>({
    variables: { after, before, first, last, orderBy, queryString },
    query: QUERY_PAYMENTS,
    context: {
      headers,
    },
  });

  if (errors && errors.length > 0) {
    errors.forEach(error => {
      // Log error details in the console.
      console.error(error);
    });
    // Friendly error to the user.
    throw new Error('An error has occurred during the query.');
  }
  return data?.payments;
};
